module.exports = __webpack_public_path__ + "img/logo-client-icon.9d13565c.png";